import { CheckCircleOutlined, CloseCircleOutlined, SyncOutlined, RightCircleOutlined } from '@ant-design/icons';
import type { InfaktSyncStatus } from 'api/swagger';
import type { ISyncIcon } from 'components/invoices/invoices-list/types';

export const INFAKT_SYNC_ICON: Record<InfaktSyncStatus, ISyncIcon> = {
  synced: { icon: <CheckCircleOutlined color='green' />, color: 'green' },
  sync_failed: { icon: <CloseCircleOutlined />, color: 'red' },
  sent: { icon: <RightCircleOutlined />, color: 'gray' },
  pending: { icon: <SyncOutlined />, color: 'gray' },
};
